<template>
    <div id="app" class="wrap no_side" v-loading="loading">
        <page-header
                v-if="!noHeader"
                :type="type"
        >
        </page-header>
        <router-view/>
    </div>
</template>
<script>
    import EventBus from "@/utils/event-bus";
    import util from "@/mixins/util";

    export default {
        name: 'App',
        data() {
            return{
                type: 'flyhigh',
                loading: false,
            }
        },
        provide() {
            return {
                changeLoading: this.changeLoading,
            }
        },
        created() {
            this.$store.dispatch('country/setLocale', {});
            if(!util.isEmpty(this.$route.meta.showOption) && this.$route.meta.showOption.hasOwnProperty('justreet') && !this.$route.meta.showOption.hasOwnProperty('flyhigh')) {
                this.type = 'justreet';
            }
        },
        computed: {
            noHeader() {
                return this.$route.meta.noHeader ? this.$route.meta.noHeader : false;
            },
        },
        methods: {
            changeMenu(type) {
                this.type = type;

                this.$nextTick(() => {
                    EventBus.$emit('runMakeMenu');
                })
            },
            changeLoading(value) {
                this.loading = value;
            },
        }
    }
</script>
<style lang="scss">
    .header_type_wrap{
        position: absolute;
        z-index: 101;
        padding-left: 15px;
        padding-top: 15px;
    }
    @import "./assets/scss/index.scss";
</style>
